import { baseApi, RtkqRequest, rtkq } from '@app/base';
import { EmployeeOverview, MyProviderListItem, ProviderAppointmentSettings } from './employeesTypes';
import {
  GetProviderHostPreferencesDocument,
  SearchProvidersByPatientDocument,
  SearchProviderDocument,
  GetProviderSettingsDocument,
} from './graphql';
import { ProviderSettings } from './providersTypes';

export const providersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    searchProviders: build.query<
      EmployeeOverview[],
      RtkqRequest<{ specialtyId?: string; from?: string; to?: string; active?: boolean | null }>
    >({
      queryFn: rtkq.graphql(SearchProviderDocument, {
        select: (x) => x.searchProvider,
        vars: ({ specialtyId, from, to, active }) => ({
          specialtyId: specialtyId ?? null,
          from: from ?? null,
          to: to ?? null,
          active: active === undefined ? true : active,
        }),
      }),
      providesTags: (result = []) => [
        ...result.flatMap(({ id }) => [
          { type: 'main:employee' as const, id },
          { type: 'main:provider-availability' as const, id },
        ]),
      ],
    }),

    getProviderAppointmentSettings: build.query<ProviderAppointmentSettings, RtkqRequest<{ id: string }>>({
      queryFn: rtkq.graphql(GetProviderHostPreferencesDocument, {
        select: (x) => x.employee?.appointmentHostPreferences! as ProviderAppointmentSettings,
        vars: ({ id }) => ({ id }),
      }),
      providesTags: (_, __, { id }) => [{ type: 'main:provider-appointment-settings', id }],
    }),

    searchProvidersByPatient: build.query<
      MyProviderListItem[],
      RtkqRequest<{ patientId: string; active?: boolean }>
    >({
      queryFn: rtkq.graphql(SearchProvidersByPatientDocument, {
        select: (x) => x.searchProvidersByPatient,
        vars: ({ patientId, active }) => ({ patientId, active: active ?? null }),
      }),
      providesTags: (result = []) => [
        ...result.flatMap(({ id }) => [{ type: 'main:employee' as const, id }]),
      ],
    }),

    getProviderSettings: build.query<ProviderSettings, RtkqRequest<{ id: string }>>({
      queryFn: rtkq.graphql(GetProviderSettingsDocument, {
        select: (x) => x.providerSettings as ProviderSettings,
        vars: ({ id }) => ({ id }),
      }),
      providesTags: (_, __, { id }) => [{ type: 'main:provider-settings', id }],
    }),
  }),
});

export const {
  useSearchProvidersQuery,
  useLazySearchProvidersQuery,
  useGetProviderAppointmentSettingsQuery,
  useSearchProvidersByPatientQuery,
  useLazySearchProvidersByPatientQuery,
  useGetProviderSettingsQuery,
} = providersApi;
